import { Dropdown, Icon } from 'semantic-ui-react'
import { DropDownMenu, MainMenuItemContainer } from '../../atoms'
import { useStore, useTracker } from '../../../store'

const CameraDropDown = () => {
  const { cameraStore, errorsStore, singleImageModeStore } = useStore()
  const tracker = useTracker()

  return (
    <Dropdown
      id="camera"
      /** @ts-ignore */
      text={
        <MainMenuItemContainer active>
          <Icon name="video camera" />
          <div>Camera</div>
          <Icon name="dropdown" />
        </MainMenuItemContainer>
      }
      icon={<></>}
      pointing="top left"
      item
      disabled={errorsStore.hasNoCameraAvailableError.value || singleImageModeStore.enabled.value}
    >
      <DropDownMenu>
        {cameraStore.availableCameras.value?.map((cameraOption) => {
          return (
            <Dropdown.Item
              style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
              key={cameraOption.id}
              disabled={cameraOption.disabled.value}
              active={cameraOption.id === cameraStore.selectedCamera.value?.id}
              selected={cameraOption.id === cameraStore.selectedCamera.value?.id}
              onClick={() => {
                tracker.sendEvent('Setting', 'camera-swtich')
                cameraStore.changeCamera(cameraOption)
              }}
            >
              {cameraOption.name}
            </Dropdown.Item>
          )
        })}
      </DropDownMenu>
    </Dropdown>
  )
}
export default CameraDropDown
